<template>
  <div>
    <div class="d-flex ga-3 justify-end">
      <v-btn
        v-if="
          isAuthor &&
          !documentAgreementSource.templateId &&
          documentAgreementSource.statusId === 1
        "
        variant="text"
        @click="updateTemplate">
        Змінити маршрут
      </v-btn>
      <v-btn
        v-if="
          isAuthor &&
          !documentAgreementSource.templateId &&
          documentAgreementSource.statusId === 1
        "
        variant="text"
        @click="updateTemplateRoutes">
        Налаштування маршрутів
      </v-btn>
    </div>

    <template-routes></template-routes>
  </div>
</template>

<script setup lang="ts">
import TemplateRoutes from './TemplateRoutes.vue'
import { useDocumentAgreement } from '../../documentAgreement'

defineOptions({
  name: 'Routes',
})

const {
  documentAgreementSource,
  isAuthor,
  updateTemplate,
  updateTemplateRoutes,
} = useDocumentAgreement()
</script>
